import(/* webpackMode: "eager" */ "/app/node_modules/@react-pdf-viewer/core/lib/styles/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@react-pdf-viewer/default-layout/lib/styles/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AnalyticsBootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "/app/src/contexts/ConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/contexts/ThemeBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/StyledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/tailwind.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/moodle.css");
